export const SHOW_TOAST_ACTION = "COMMON:SHOW_TOAST";

export const showToastAction = (
  type: "success" | "info" | "error",
  message: string
) => ({
  type: SHOW_TOAST_ACTION as typeof SHOW_TOAST_ACTION,
  messageType: type,
  message,
});

export type ShowToastAction = ReturnType<typeof showToastAction>;
